import React, { useState } from 'react';
import { MdContentCopy, MdCheckCircle, MdShoppingCart, MdChat } from 'react-icons/md';
import { SiPhonepe, SiGooglepay, SiPaytm } from 'react-icons/si';
import { FaQrcode, FaWhatsapp, FaSearch } from 'react-icons/fa';
import { BiSelectMultiple } from 'react-icons/bi';
import './Payment.css';

const Payment = () => {
    const [copiedField, setCopiedField] = useState('');

    const upiId = 'rakhibhagat41@okhdfcband';
    const upiNumber = '9437737336';

    const handleCopy = (text, field) => {
        navigator.clipboard.writeText(text);
        setCopiedField(field);
        setTimeout(() => setCopiedField(''), 2000);
    };

    const handleUPIPayment = (app) => {
        // For web, we'll just copy the UPI ID and show instructions
        handleCopy(upiId, 'upiId');
        alert(`UPI ID copied! Open ${app === 'phonepe' ? 'PhonePe' : app === 'googlepay' ? 'Google Pay' : 'Paytm'} app and paste the UPI ID to make payment.`);
    };

    return (
        <div className="payment-page">
            <div className="page-header">
                <h1>How to Order & Payment</h1>
                <p>Simple steps to place your order</p>
            </div>

            <div className="payment-container">
                {/* How to Order Section */}
                <div className="payment-section how-to-order-section">
                    <div className="section-header">
                        <MdShoppingCart size={24} color="#e63946" />
                        <h2>How to Place an Order</h2>
                    </div>

                    <div className="order-steps">
                        <div className="order-step">
                            <div className="step-number">
                                <FaSearch size={20} />
                            </div>
                            <div className="step-content">
                                <h3>Browse Products</h3>
                                <p>Explore our wide range of authentic Sambalpuri textiles, sarees, and dress materials. Use categories to find exactly what you're looking for.</p>
                            </div>
                        </div>

                        <div className="order-step">
                            <div className="step-number">
                                <BiSelectMultiple size={24} />
                            </div>
                            <div className="step-content">
                                <h3>Add to Cart</h3>
                                <p>Select your favorite products and add them to cart. You can add multiple items and adjust quantities as needed.</p>
                            </div>
                        </div>

                        <div className="order-step">
                            <div className="step-number">
                                <FaWhatsapp size={22} />
                            </div>
                            <div className="step-content">
                                <h3>Send Inquiry via WhatsApp</h3>
                                <p>Go to your cart and click "Send Inquiry via WhatsApp". Your cart details will be sent directly to our WhatsApp. We'll confirm product availability, pricing, and delivery details.</p>
                            </div>
                        </div>

                        <div className="order-step">
                            <div className="step-number">
                                <MdChat size={22} />
                            </div>
                            <div className="step-content">
                                <h3>Confirm Your Order</h3>
                                <p>We will respond with final pricing, shipping charges, and expected delivery time. Once you confirm, proceed with payment using the methods below.</p>
                            </div>
                        </div>
                    </div>

                    <div className="order-note-box">
                        <p><strong>💡 Note:</strong> All orders are confirmed via WhatsApp at <strong>+91 9437737336</strong>. We'll provide personalized assistance for bulk orders, custom requirements, or any special requests.</p>
                    </div>
                </div>

                <div className="section-divider">
                    <span>Payment Methods</span>
                </div>
                {/* UPI Payment Section */}
                <div className="payment-section">
                    <div className="section-header">
                        <FaQrcode size={24} color="#e63946" />
                        <h2>Pay via UPI</h2>
                    </div>

                    <div className="upi-apps">
                        <button 
                            className="upi-app-btn phonepe"
                            onClick={() => handleUPIPayment('phonepe')}
                        >
                            <SiPhonepe size={28} />
                            <span>PhonePe</span>
                        </button>
                        <button 
                            className="upi-app-btn googlepay"
                            onClick={() => handleUPIPayment('googlepay')}
                        >
                            <SiGooglepay size={28} />
                            <span>Google Pay</span>
                        </button>
                        <button 
                            className="upi-app-btn paytm"
                            onClick={() => handleUPIPayment('paytm')}
                        >
                            <SiPaytm size={28} />
                            <span>Paytm</span>
                        </button>
                    </div>

                    <div className="payment-divider">
                        <span>OR</span>
                    </div>

                    {/* UPI ID Section */}
                    <div className="payment-details-card">
                        <h3>UPI ID</h3>
                        <div className="detail-row">
                            <div className="detail-content">
                                <span className="detail-label">ID:</span>
                                <span className="detail-value">{upiId}</span>
                            </div>
                            <button 
                                className="copy-btn"
                                onClick={() => handleCopy(upiId, 'upiId')}
                            >
                                {copiedField === 'upiId' ? (
                                    <MdCheckCircle size={20} color="#28a745" />
                                ) : (
                                    <MdContentCopy size={20} />
                                )}
                            </button>
                        </div>
                    </div>

                    {/* UPI Number Section */}
                    <div className="payment-details-card">
                        <h3>UPI Number</h3>
                        <div className="detail-row">
                            <div className="detail-content">
                                <span className="detail-label">Number:</span>
                                <span className="detail-value">{upiNumber}</span>
                            </div>
                            <button 
                                className="copy-btn"
                                onClick={() => handleCopy(upiNumber, 'upiNumber')}
                            >
                                {copiedField === 'upiNumber' ? (
                                    <MdCheckCircle size={20} color="#28a745" />
                                ) : (
                                    <MdContentCopy size={20} />
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Instructions */}
                <div className="payment-instructions">
                    <h3>Payment Instructions</h3>
                    <ol>
                        <li>Click on your preferred UPI app button above</li>
                        <li>Or copy the UPI ID/Number and paste in your payment app</li>
                        <li>Enter the amount to pay</li>
                        <li>Complete the payment</li>
                        <li>Share the payment screenshot via WhatsApp for order confirmation</li>
                    </ol>
                </div>

                {/* Note */}
                <div className="payment-note">
                    <p><strong>Note:</strong> After completing the payment, please share the payment screenshot to our WhatsApp number <strong>9437737336</strong> for quick order confirmation and processing.</p>
                </div>
                <div className="payment-note">
                    <p><strong>Note:</strong> We ship our products with Speed Post. <strong>No COD Available.</strong></p>
                </div>
            </div>
        </div>
    );
};

export default Payment;
